var EnvestnetYodleeLabel = 'https://cdn.yodlee.com/resource/yodlee/images/brand/PNG/yodlee-darkpurple.png';
var EnvestnetYodlee = 'https://cdn.yodlee.com/resource/yodlee/images/brand/SVG/yodlee-logo.svg';
export { EnvestnetYodlee, EnvestnetYodleeLabel };
//# sourceMappingURL=index.js.map